var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "field-manager__field-list-pane",
      class: { "is-draging": _vm.isDraging },
    },
    [
      _c(
        "div",
        { staticClass: "field-manager__field-list-pane__left-container" },
        [
          _c("div", { staticClass: "field-manager__field-list-pane__label" }, [
            _vm._v(
              " " + _vm._s(_vm.$t("PtFieldManagerPanel.avaliableFields")) + " "
            ),
          ]),
          _c("div", { staticClass: "field-manager__field-list-pane__tab" }, [
            _c(
              "div",
              {
                staticClass: "field-manager__field-list-pane__tab-item",
                class: {
                  active: _vm.currentTab === _vm.FieldTabType.STANDARD,
                },
                on: {
                  click: function ($event) {
                    return _vm.setCurrentTab(_vm.FieldTabType.STANDARD)
                  },
                },
              },
              [
                _vm._v(
                  " " +
                    _vm._s(_vm.$t("PtFieldManagerPanel.patentFields")) +
                    " (" +
                    _vm._s(_vm.standardFieldKeyList.length) +
                    ") "
                ),
              ]
            ),
            _c(
              "div",
              {
                staticClass: "field-manager__field-list-pane__tab-item",
                class: {
                  active: _vm.currentTab === _vm.FieldTabType.CUSTOM_FIELD,
                },
                on: {
                  click: function ($event) {
                    return _vm.setCurrentTab(_vm.FieldTabType.CUSTOM_FIELD)
                  },
                },
              },
              [
                _vm._v(
                  " " +
                    _vm._s(_vm.$t("PtFieldManagerPanel.customFields")) +
                    " (" +
                    _vm._s(_vm.customFieldKeyList.length) +
                    ") "
                ),
              ]
            ),
          ]),
          _c(
            "div",
            { staticClass: "field-manager__field-list-pane__search-container" },
            [
              _c("PtIcon", { attrs: { icon: "SolidSearchLeft" } }),
              _vm.filter
                ? _c("PtIcon", {
                    attrs: { icon: "SolidCloseBig" },
                    on: {
                      click: function ($event) {
                        _vm.filter = ""
                      },
                    },
                  })
                : _vm._e(),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.filter,
                    expression: "filter",
                  },
                ],
                attrs: {
                  type: "text",
                  placeholder: _vm.$t("PtFieldManagerPanel.searchPlaceholder"),
                },
                domProps: { value: _vm.filter },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.filter = $event.target.value
                  },
                },
              }),
            ],
            1
          ),
          _vm.currentTab === _vm.FieldTabType.CUSTOM_FIELD
            ? _vm._t("CustomFieldListHeader")
            : _vm._e(),
          _c(
            "div",
            { staticClass: "field-manager__field-list-pane__list" },
            [
              !_vm.currentTabListFiltered.length
                ? _c(
                    "div",
                    { staticClass: "no-data" },
                    [
                      _c("PtIcon", { attrs: { icon: "SolidNoDataTip" } }),
                      _c("p", [_vm._v(_vm._s(_vm.noDataText))]),
                    ],
                    1
                  )
                : _vm._l(_vm.currentTabListFiltered, function (key) {
                    return _c(
                      "FieldInfoPopover",
                      {
                        key: key,
                        attrs: {
                          field: _vm.getFieldItem(key),
                          disabled:
                            ["LAYER", "OPTION"].indexOf(
                              _vm.getFieldItem(key).fieldType
                            ) === -1,
                          getOptionOrLayerFieldInfoPromise:
                            _vm.getOptionOrLayerFieldInfoPromiseCacheFn,
                        },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "field-manager__field-list-pane__list-item",
                            class: {
                              "is-toggle-visible-disabled":
                                _vm.isToggleVisibleDisabled(
                                  key,
                                  _vm.getFieldItem(key),
                                  _vm.fieldMap
                                ),
                              "is-sort-disabled": _vm.isSortDisabled(
                                key,
                                _vm.getFieldItem(key),
                                _vm.fieldMap
                              ),
                              "is-checked": _vm.isChecked(key),
                            },
                            attrs: { "data-field-key": key },
                            on: {
                              click: function ($event) {
                                return _vm.clickField(key)
                              },
                            },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "field-manager__field-list-pane__list-item__left",
                              },
                              [
                                _c(
                                  "ElTooltip",
                                  {
                                    attrs: {
                                      disabled:
                                        !_vm.getFieldLabelScopeIsSpace(key),
                                      effect: "light",
                                      "visible-arrow": false,
                                      content: _vm.spaceScopeFieldTip
                                        ? _vm.spaceScopeFieldTip
                                        : _vm.$t(
                                            "PtFieldManagerPanel.spaceScopeFieldTip"
                                          ),
                                      placement: "top",
                                      "popper-class": "pt-ui-tooltip",
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "scope-field-icon" },
                                      [
                                        _vm.getFieldLabelScope(key) === "SPACE"
                                          ? _c("div", {
                                              staticClass:
                                                "scope-field-icon__triangle",
                                            })
                                          : _vm._e(),
                                        _vm.getFieldIcon(key)
                                          ? _c("PtIcon", {
                                              style: {
                                                color: _vm.getFieldColor(key),
                                              },
                                              attrs: {
                                                icon: _vm.getFieldIcon(key),
                                              },
                                            })
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                                _c("div", {
                                  staticClass:
                                    "field-manager__field-list-pane__list-item__field-name",
                                  attrs: {
                                    title: _vm.getFieldItem(key).displayName,
                                  },
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.getFieldHighlightDisplayName(key)
                                    ),
                                  },
                                }),
                                _vm.getIsNewField(key)
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "field-manager__field-list-pane__list-item__new-field-tag",
                                      },
                                      [_vm._v("New")]
                                    )
                                  : _vm._e(),
                                _vm.getIsPatsnapAiField(key)
                                  ? _c("PtIcon", {
                                      staticClass:
                                        "field-manager__field-list-pane__list-item__patent-ai-field-tag",
                                      attrs: { icon: "SolidAiField" },
                                    })
                                  : _vm._e(),
                                _vm.getFieldItem(key).tips
                                  ? _c(
                                      "ElPopover",
                                      {
                                        attrs: {
                                          trigger: "hover",
                                          placement: "top",
                                          "visible-arrow": false,
                                          "popper-class": [
                                            "pt-ui-popover",
                                            "field-manager__field-list-pane__list-item__popper",
                                          ].join(" "),
                                          content: _vm.getFieldItem(key).tips,
                                        },
                                      },
                                      [
                                        _c("PtIcon", {
                                          staticClass:
                                            "field-manager__field-list-pane__list-item__icon",
                                          attrs: {
                                            slot: "reference",
                                            icon: "SolidInfo",
                                          },
                                          slot: "reference",
                                        }),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                            _c("PtCheckbox", {
                              attrs: {
                                checked: _vm.isChecked(key),
                                disabled: _vm.isToggleVisibleDisabled(
                                  key,
                                  _vm.getFieldItem(key),
                                  _vm.fieldMap
                                ),
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    )
                  }),
            ],
            2
          ),
        ],
        2
      ),
      _c(
        "div",
        { staticClass: "field-manager__field-list-pane__right-container" },
        [
          _c("div", { staticClass: "field-manager__field-list-pane__label" }, [
            _vm._v(
              " " +
                _vm._s(_vm.$t("PtFieldManagerPanel.displayFields")) +
                " (" +
                _vm._s(_vm.visibleFieldKeyList.length) +
                ") "
            ),
          ]),
          _c(
            "DraggableList",
            {
              staticClass: "field-manager__field-list-pane__list",
              attrs: {
                value: _vm.visibleFieldKeyList,
                draggable: ".is-draggable",
                handle: ".drag-handle",
                "fallback-tolerance": 1,
                "force-fallback": true,
              },
              on: {
                change: _vm.updateFieldSort,
                start: _vm.onDragStart,
                end: _vm.onDragEnd,
              },
            },
            _vm._l(_vm.visibleFieldKeyList, function (key) {
              return _c(
                "FieldInfoPopover",
                {
                  key: key,
                  class: {
                    "drag-handle": true,
                    "is-draggable": !_vm.isSortDisabled(
                      key,
                      _vm.getFieldItem(key),
                      _vm.fieldMap
                    ),
                  },
                  attrs: {
                    field: _vm.getFieldItem(key),
                    disabled:
                      ["LAYER", "OPTION"].indexOf(
                        _vm.getFieldItem(key).fieldType
                      ) === -1,
                    getOptionOrLayerFieldInfoPromise:
                      _vm.getOptionOrLayerFieldInfoPromiseCacheFn,
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "field-manager__field-list-pane__list-item",
                      class: {
                        "is-toggle-visible-disabled":
                          _vm.isToggleVisibleDisabled(
                            key,
                            _vm.getFieldItem(key),
                            _vm.fieldMap
                          ),
                        "is-sort-disabled": _vm.isSortDisabled(
                          key,
                          _vm.getFieldItem(key),
                          _vm.fieldMap
                        ),
                      },
                      attrs: { "data-field-key": key },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "field-manager__field-list-pane__list-item__left",
                        },
                        [
                          _vm.isSortIconVisible(
                            key,
                            _vm.getFieldItem(key),
                            _vm.fieldMap
                          )
                            ? _c("PtIcon", { attrs: { icon: "SolidMove" } })
                            : _vm._e(),
                          _c(
                            "ElTooltip",
                            {
                              attrs: {
                                disabled: !_vm.getFieldLabelScopeIsSpace(key),
                                effect: "light",
                                "visible-arrow": false,
                                content: _vm.spaceScopeFieldTip
                                  ? _vm.spaceScopeFieldTip
                                  : _vm.$t(
                                      "PtFieldManagerPanel.spaceScopeFieldTip"
                                    ),
                                placement: "top",
                                "popper-class": "pt-ui-tooltip",
                              },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "scope-field-icon" },
                                [
                                  _vm.getFieldLabelScope(key) === "SPACE"
                                    ? _c("div", {
                                        staticClass:
                                          "scope-field-icon__triangle",
                                      })
                                    : _vm._e(),
                                  _vm.getFieldIcon(key)
                                    ? _c("PtIcon", {
                                        style: {
                                          color: _vm.getFieldColor(key),
                                        },
                                        attrs: { icon: _vm.getFieldIcon(key) },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticClass:
                                "field-manager__field-list-pane__list-item__field-name",
                              attrs: {
                                title: _vm.getFieldItem(key).displayName,
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.getFieldItem(key).displayName) +
                                  " "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      !_vm.isToggleVisibleDisabled(
                        key,
                        _vm.getFieldItem(key),
                        _vm.fieldMap
                      )
                        ? _c("PtIcon", {
                            attrs: { icon: "SolidDelete" },
                            on: {
                              click: function ($event) {
                                return _vm.clickField(key)
                              },
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              )
            }),
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }